import { ChevronLeft } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/common/components/ui/button';
import { cn } from '@/lib/utils';

interface Props {
  onBack: () => void;
  className?: string;
}

export const ChevronBackButton = ({ onBack, className }: Props) => {
  const { t } = useTranslation();

  return (
    <Button
      onClick={onBack}
      variant="ghost"
      size="icon"
      className={cn(
        'size-auto p-2 text-warm-gray-50 transition-colors [&>svg]:hover:text-[#b15334]',
        className,
      )}
      aria-label={t('navigation.back')}
    >
      <ChevronLeft size={20} />
    </Button>
  );
};
